import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    listAutoprofileForms: (idList, filterParams) =>
      `${baseURL}/api/lists/${encodeURIComponent(
        idList
      )}/autoprofileforms?${encodeParams(filterParams)}`,
    getSubscriptionFormListUsingConfirmationMsg: idMessage =>
      `${baseURL}/api/subscriptionformsbyconfirmsg/${encodeURIComponent(
        idMessage
      )}`
  }
})(process.env.BEFORM_URL)

/**
 * @typedef {Object} AutoprofileFormItem
 * @property {boolean} Enabled
 * @property {string} Start
 * @property {number} IdGroup
 * @property {boolean} CaptchaEnabled
 * @property {boolean} Public
 * @property {string} Name
 * @property {string} UniqueFill
 * @property {boolean} HasStructure
 * @property {string} End
 * @property {number} Id
 * @property {string} Description
 *
 * @typedef {Object} AutoprofileFormPagedList
 * @property {Array<AutoprofileFormItem>} Items
 * @property {number} PageNumber
 * @property {number} PageSize
 * @property {number} TotalItems
 *
 * @description return list of autoprofileforms
 * @param {number} idList list id
 * @param {Object} filterParams
 * @param {boolean} filterParams.enabled flag to filter enabled or disabled forms
 * @param {number} filterParams.pageSize Number of form returned
 * @param {number} filterParams.pageNumber Page number
 * @param {string} filterParams.orderBy Order by specified field
 * @param {boolean} filterParams.orderDescending Order descending
 * @returns {AutoprofileFormPagedList}
 */
export const beFormListAutoprofileForms = (idList, filterParams) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.listAutoprofileForms(idList, filterParams)
  }).then(({ data }) => data)
}

export const beFormApiGetSubscriptionFormsUsingMessage = idMessage => {
  const url = endpoints.getSubscriptionFormListUsingConfirmationMsg(idMessage)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(({ data }) => data)
}
